import {ProcessFlowchartPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {makeReactContext} from 'lib/makeReactContext';

import {FEATURE_OVERRIDES_FOR_EDITOR_MODE, FlowchartEditorMode} from './ProcessFlowchartEditorModeConstants';

export type PlatformFlowchartFeatures = Map<ProcessFlowchartPlatformFeatureType, boolean>;

/** Context to provide platform flowchart features to child components */
export const PlatformFeaturesContext = makeReactContext<PlatformFlowchartFeatures | undefined>(
  () => undefined,
  'PlatformFeaturesContext'
);

export function getValueForPlatformFeaturesContext(
  configuratorPlatformFeatures: PlatformFlowchartFeatures,
  mode: FlowchartEditorMode
): PlatformFlowchartFeatures {
  const overrides = FEATURE_OVERRIDES_FOR_EDITOR_MODE[mode];
  const coalescedPlatformFeatures = new Map<ProcessFlowchartPlatformFeatureType, boolean>();
  for (const [feature, value] of configuratorPlatformFeatures) {
    if (overrides[feature] != null) {
      coalescedPlatformFeatures.set(feature, overrides[feature]);
    } else {
      coalescedPlatformFeatures.set(feature, value);
    }
  }
  return coalescedPlatformFeatures;
}
